<template>
  <div>
    <component
      :is="componentFile"
    />
  </div>
</template>
<script>

export default{
	computed: {
		componentFile() {
        return () => import(`./articles/${this.$route.params.name}.vue`);
    }, 
    errorFile(){
      return () => import(`./NotFound.vue`);
    }
  },
  metaInfo() {
    return {
      title: this.textEllipsis(`Article`, 25),
    };
  },
}
</script>